export default __webpack_public_path__ + "static/media/my-account.546bf24e.svg";